<template>
  <v-app class="promo-app-bg">
    <!-- App Bar -->
    <v-app-bar
      app
      :color="this.$pgsHelper.uiConfig().mainColor"
      dark
      class="elevation-4 promo-appbar"
    >
      <v-app-bar-nav-icon>
        <v-icon>mdi-tag-multiple</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="promo-appbar-title">
        {{ this.$pgsHelper.uiConfig().appName }}
      </v-toolbar-title>
      <v-spacer />
      <v-chip
        small
        class="mr-2 promo-mode-chip"
        color="white"
        text-color="primary"
      >
        <v-icon left small>mdi-tag-text</v-icon>
        {{ $route.params.idPromocion ? "Editar Promoción" : "Nueva Promoción" }}
      </v-chip>
    </v-app-bar>

    <!-- Loading overlay -->
    <v-overlay :value="loading" z-index="999">
      <div class="promo-loading-wrapper">
        <v-progress-circular
          indeterminate
          size="64"
          width="5"
          color="primary"
        />
        <p class="mt-4 white--text body-1">Cargando información...</p>
      </div>
    </v-overlay>

    <!-- Main content -->
    <v-container fluid class="mt-16 px-4 pb-8">
      <v-row>
        <!-- Sidebar de acciones -->
        <v-col cols="12" md="2">
          <v-card class="promo-sidebar" elevation="3" rounded="lg">
            <div class="promo-sidebar-header">
              <v-icon color="white" class="mr-2">mdi-cog-outline</v-icon>
              <span>Opciones</span>
            </div>
            <v-list dense nav class="py-2">
              <!-- Guardar nueva -->
              <v-list-item
                v-if="!$route.params.idPromocion"
                @click="addPromocion"
                class="promo-sidebar-item promo-sidebar-item--save"
                rounded
              >
                <v-list-item-icon>
                  <v-icon color="success">mdi-content-save</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium"
                    >Guardar</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <!-- Guardar edición -->
              <v-list-item
                v-if="$route.params.idPromocion"
                @click="editPromocion"
                class="promo-sidebar-item promo-sidebar-item--save"
                rounded
              >
                <v-list-item-icon>
                  <v-icon color="success">mdi-content-save-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium"
                    >Guardar Cambios</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-divider class="my-2" />

              <!-- Volver -->
              <v-list-item
                @click="goRoute('/productos-inventarios/promociones')"
                class="promo-sidebar-item promo-sidebar-item--back"
                rounded
              >
                <v-list-item-icon>
                  <v-icon color="error">mdi-arrow-left-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium"
                    >Volver</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <!-- Estado de la promocion -->
            <div class="promo-status-panel mx-3 mb-3">
              <div class="promo-status-label">Estado</div>
              <v-chip
                small
                :color="Promocion.Vigencia.E ? 'success' : 'grey'"
                text-color="white"
                class="promo-status-chip"
              >
                <v-icon left small>{{
                  Promocion.Vigencia.E ? "mdi-check-circle" : "mdi-pause-circle"
                }}</v-icon>
                {{ Promocion.Vigencia.E ? "Activa" : "Inactiva" }}
              </v-chip>
              <v-chip
                v-if="Promocion.Membresia"
                small
                color="deep-purple"
                text-color="white"
                class="mt-1 promo-status-chip"
              >
                <v-icon left small>mdi-crown</v-icon>
                Membresía
              </v-chip>
            </div>
          </v-card>
        </v-col>

        <!-- Contenido principal -->
        <v-col cols="12" md="10">
          <v-row>
            <!-- ══════════════════ PANEL IZQUIERDO: Detalle ══════════════════ -->
            <v-col cols="12" md="6">
              <v-card class="promo-panel" elevation="3" rounded="lg">
                <!-- Header del panel -->
                <div class="promo-panel-header">
                  <v-icon color="white" class="mr-2">mdi-tag-outline</v-icon>
                  <span>Detalle de la Promoción</span>
                </div>

                <v-card-text class="pt-4 pb-5 px-5">
                  <!-- Nombre -->
                  <v-text-field
                    v-model="Promocion.Nombre"
                    label="Nombre de la promoción"
                    outlined
                    dense
                    prepend-inner-icon="mdi-tag-text"
                    class="promo-field"
                    placeholder="Ej: Descuento de verano"
                  />

                  <!-- Switches -->
                  <div class="promo-switches-row">
                    <div class="promo-switch-card">
                      <v-switch
                        label="Activo"
                        v-model="Promocion.Vigencia.E"
                        color="success"
                        inset
                        dense
                        hide-details
                        class="promo-switch"
                      />
                    </div>
                    <div class="promo-switch-card">
                      <v-switch
                        label="Exclusivo Membresía"
                        v-model="Promocion.Membresia"
                        color="deep-purple"
                        inset
                        dense
                        hide-details
                        class="promo-switch"
                      />
                    </div>
                  </div>

                  <!-- Fechas -->
                  <div class="promo-section-label mt-4 mb-2">
                    <v-icon small class="mr-1" color="primary"
                      >mdi-calendar-range</v-icon
                    >
                    Vigencia
                  </div>

                  <div class="promo-date-block">
                    <div class="promo-date-label">Fecha Inicial</div>
                    <div v-if="dateI" class="input promo-datepicker-wrapper">
                      <Datepicker
                        @selected="selectDate"
                        :value="dateI.format('MM/DD/YYYY')"
                        input-class="promo-datepicker-input"
                      />
                    </div>
                  </div>

                  <v-expand-transition>
                    <div v-if="!unlimitDate" class="promo-date-block mt-2">
                      <div class="promo-date-label">Fecha Final</div>
                      <div class="input promo-datepicker-wrapper">
                        <Datepicker
                          @selected="selectDateFinal"
                          :value="dateF ? dateF.format('MM/DD/YYYY') : ''"
                          input-class="promo-datepicker-input"
                        />
                      </div>
                    </div>
                  </v-expand-transition>

                  <div class="promo-switch-card mt-2">
                    <v-switch
                      label="Sin límite de tiempo"
                      @change="changeDateLimit()"
                      v-model="unlimitDate"
                      color="info"
                      inset
                      dense
                      hide-details
                      class="promo-switch"
                    />
                  </div>

                  <!-- Departamentos -->
                  <div class="promo-section-label mt-4 mb-2">
                    <v-icon small class="mr-1" color="primary"
                      >mdi-store</v-icon
                    >
                    Departamentos
                  </div>
                  <v-select
                    multiple
                    :items="modulos"
                    label="Selecciona departamentos"
                    v-model="Promocion.Departamentos"
                    outlined
                    dense
                    prepend-inner-icon="mdi-store-outline"
                    chips
                    small-chips
                    deletable-chips
                    class="promo-field"
                  />

                  <!-- Peso -->
                  <v-text-field
                    v-model="Promocion.Peso"
                    label="Peso de importancia"
                    outlined
                    dense
                    prepend-inner-icon="mdi-weight"
                    type="number"
                    class="promo-field"
                    hint="Mayor número = mayor prioridad"
                    persistent-hint
                  />

                  <!-- ─── Tabla de Reglas ─── -->
                  <div class="promo-section-label mt-5 mb-2">
                    <v-icon small class="mr-1" color="indigo"
                      >mdi-filter-outline</v-icon
                    >
                    Reglas configuradas
                    <v-chip
                      x-small
                      color="indigo"
                      text-color="white"
                      class="ml-2"
                      >{{ listaReglas.length }}</v-chip
                    >
                  </div>

                  <div
                    v-if="listaReglas.length === 0"
                    class="promo-empty-state"
                  >
                    <v-icon color="grey lighten-1" size="32"
                      >mdi-filter-off-outline</v-icon
                    >
                    <p class="grey--text text--lighten-1 caption mt-1 mb-0">
                      Sin reglas aún
                    </p>
                  </div>

                  <v-simple-table v-else class="promo-table" dense>
                    <thead>
                      <tr>
                        <th>Regla</th>
                        <th>Subregla</th>
                        <th>Operador</th>
                        <th>Valor</th>
                        <th>Referencia</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(regla, index) in listaReglas">
                        <tr :key="index" class="promo-table-row">
                          <td>
                            <v-chip
                              x-small
                              color="indigo lighten-4"
                              text-color="indigo darken-3"
                              >{{ regla.Regla }}</v-chip
                            >
                          </td>
                          <td class="caption">{{ regla.Subregla }}</td>
                          <td>
                            <v-chip
                              x-small
                              color="blue lighten-4"
                              text-color="blue darken-3"
                              >{{ regla.Operador }}</v-chip
                            >
                          </td>
                          <td class="caption font-weight-medium">
                            {{
                              regla.valorName ? regla.valorName : regla.Valor
                            }}
                          </td>
                          <td class="caption">
                            {{ regla.refName ? regla.refName : regla.Ref }}
                          </td>
                          <td>
                            <v-btn
                              icon
                              x-small
                              color="error"
                              @click="
                                deleteRule(regla.parentIndex, regla.objIndex)
                              "
                            >
                              <v-icon x-small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>

                  <!-- ─── Tabla de Acciones ─── -->
                  <div class="promo-section-label mt-5 mb-2">
                    <v-icon small class="mr-1" color="teal"
                      >mdi-lightning-bolt</v-icon
                    >
                    Acciones configuradas
                    <v-chip
                      x-small
                      color="teal"
                      text-color="white"
                      class="ml-2"
                      >{{ listaAcciones.length }}</v-chip
                    >
                  </div>

                  <div
                    v-if="listaAcciones.length === 0"
                    class="promo-empty-state"
                  >
                    <v-icon color="grey lighten-1" size="32"
                      >mdi-lightning-bolt-outline</v-icon
                    >
                    <p class="grey--text text--lighten-1 caption mt-1 mb-0">
                      Sin acciones aún
                    </p>
                  </div>

                  <v-simple-table v-else class="promo-table" dense>
                    <thead>
                      <tr>
                        <th>Acción</th>
                        <th>Operador</th>
                        <th>Valor</th>
                        <th>Referencia</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(regla, index) in listaAcciones">
                        <tr :key="index" class="promo-table-row">
                          <td>
                            <v-chip
                              x-small
                              color="teal lighten-4"
                              text-color="teal darken-3"
                              >{{ regla.Tipo }}</v-chip
                            >
                          </td>
                          <td>
                            <v-chip
                              x-small
                              color="cyan lighten-4"
                              text-color="cyan darken-3"
                              >{{ regla.Variacion }}</v-chip
                            >
                          </td>
                          <td class="caption font-weight-medium">
                            {{
                              regla.valorName ? regla.valorName : regla.Valor
                            }}
                          </td>
                          <td class="caption">
                            {{ regla.refName ? regla.refName : regla.Ref }}
                          </td>
                          <td>
                            <v-btn
                              icon
                              x-small
                              color="error"
                              @click="deleteAccion(index)"
                            >
                              <v-icon x-small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- ══════════════════ PANEL DERECHO: Constructor ══════════════════ -->
            <v-col cols="12" md="6">
              <v-card class="promo-panel" elevation="3" rounded="lg">
                <div class="promo-panel-header promo-panel-header--builder">
                  <v-icon color="white" class="mr-2">mdi-tools</v-icon>
                  <span>Constructor de Reglas y Acciones</span>
                </div>

                <v-card-text class="pt-4 pb-5 px-5">
                  <!-- Toggle Regla / Acción -->
                  <div class="promo-toggle-group mb-4">
                    <button
                      class="promo-toggle-btn"
                      :class="{
                        'promo-toggle-btn--active': typeOperation == 1,
                      }"
                      @click="
                        typeOperation = 1;
                        tipoAccion = '';
                      "
                      type="button"
                    >
                      <v-icon small class="mr-1">mdi-filter</v-icon>
                      Regla
                    </button>
                    <button
                      class="promo-toggle-btn"
                      :class="{
                        'promo-toggle-btn--active': typeOperation == 2,
                      }"
                      @click="
                        typeOperation = 2;
                        tipoRegla = '';
                      "
                      type="button"
                    >
                      <v-icon small class="mr-1">mdi-lightning-bolt</v-icon>
                      Acción
                    </button>
                  </div>

                  <!-- ─── FORMULARIO REGLA ─── -->
                  <v-slide-x-transition>
                    <div v-if="typeOperation == 1" key="regla-selector">
                      <v-select
                        v-model="tipoRegla"
                        :items="catalogoReglas.Reglas"
                        item-value="id"
                        item-text="id"
                        @change="changeRegla"
                        label="Tipo de regla"
                        outlined
                        dense
                        prepend-inner-icon="mdi-shape-outline"
                        class="promo-field"
                        clearable
                      />
                    </div>
                  </v-slide-x-transition>

                  <!-- ─── FORMULARIO ACCIÓN ─── -->
                  <v-slide-x-reverse-transition>
                    <div v-if="typeOperation == 2" key="accion-selector">
                      <v-select
                        v-model="tipoAccion"
                        :items="catalogoReglas.Acciones"
                        item-value="id"
                        item-text="id"
                        @change="changeAccion"
                        label="Tipo de Acción"
                        outlined
                        dense
                        prepend-inner-icon="mdi-lightning-bolt-outline"
                        class="promo-field"
                        clearable
                      />
                    </div>
                  </v-slide-x-reverse-transition>

                  <!-- ─── Campos de SubRegla ─── -->
                  <v-expand-transition>
                    <div v-if="tipoRegla != ''" class="promo-subform">
                      <div class="promo-subform-label">
                        <v-icon small color="indigo" class="mr-1"
                          >mdi-filter-plus</v-icon
                        >
                        Configurar SubRegla
                      </div>

                      <v-select
                        label="SubRegla"
                        @change="changeSubRegla"
                        :items="operables"
                        v-model="subRegla.Tipo"
                        outlined
                        dense
                        prepend-inner-icon="mdi-tune"
                        class="promo-field"
                      />

                      <!-- Referencias de subregla -->
                      <v-autocomplete
                        v-if="inputRefCategoria"
                        :items="categories"
                        item-value="value"
                        item-text="text"
                        v-model="subRegla.Ref"
                        label="Seleccione una Categoría"
                        outlined
                        dense
                        prepend-inner-icon="mdi-shape"
                        class="promo-field"
                        clearable
                      />
                      <v-autocomplete
                        v-if="inputRefProducto"
                        :items="productosSearch"
                        item-value="value"
                        item-text="text"
                        v-model="subRegla.Ref"
                        label="Seleccione un Producto"
                        outlined
                        dense
                        prepend-inner-icon="mdi-package-variant"
                        class="promo-field"
                        clearable
                      />
                      <v-text-field
                        v-model="subRegla.Ref"
                        v-if="inputRefTag"
                        type="text"
                        placeholder="Tag de referencia"
                        label="Nombre del tag de referencia"
                        outlined
                        dense
                        prepend-inner-icon="mdi-tag"
                        class="promo-field"
                      />

                      <!-- Operador y Valor -->
                      <v-row dense>
                        <v-col cols="12" sm="5">
                          <v-select
                            label="Operador"
                            v-model="subRegla.Operador"
                            :items="catalogoReglas.Operadores"
                            outlined
                            dense
                            prepend-inner-icon="mdi-compare"
                            class="promo-field"
                          />
                        </v-col>
                        <v-col cols="12" sm="7">
                          <!-- Valor por tipo -->
                          <v-autocomplete
                            v-if="inputProducto"
                            :items="productosSearch"
                            item-value="value"
                            item-text="text"
                            v-model="subRegla.Valor"
                            label="Seleccione un Producto"
                            outlined
                            dense
                            prepend-inner-icon="mdi-package-variant"
                            class="promo-field"
                            clearable
                          />
                          <v-autocomplete
                            v-if="inputCategoria"
                            :items="categories"
                            item-value="value"
                            item-text="text"
                            v-model="subRegla.Valor"
                            label="Seleccione una Categoría"
                            outlined
                            dense
                            prepend-inner-icon="mdi-shape"
                            class="promo-field"
                            clearable
                          />
                          <v-autocomplete
                            v-if="inputFamilias"
                            :items="Familias"
                            item-value="value"
                            item-text="text"
                            v-model="subRegla.Valor"
                            label="Seleccione una Familia"
                            outlined
                            dense
                            prepend-inner-icon="mdi-family-tree"
                            class="promo-field"
                            clearable
                          />
                          <v-autocomplete
                            v-if="inputCliente"
                            :items="clientesSearch"
                            item-value="value"
                            item-text="text"
                            v-model="subRegla.Valor"
                            label="Seleccione un Cliente"
                            outlined
                            dense
                            prepend-inner-icon="mdi-account"
                            class="promo-field"
                            clearable
                          />
                          <v-autocomplete
                            v-if="inputClienteGroup"
                            :items="gruposCliente"
                            item-value="value"
                            item-text="text"
                            v-model="subRegla.Valor"
                            label="Seleccione un Grupo"
                            outlined
                            dense
                            prepend-inner-icon="mdi-account-group"
                            class="promo-field"
                            clearable
                          />
                          <v-text-field
                            v-model="subRegla.Valor"
                            v-if="inputTimeRange"
                            v-mask="'##:##-##:##'"
                            type="text"
                            placeholder="Ej: 08:00-20:00"
                            label="Rango de hora"
                            outlined
                            dense
                            prepend-inner-icon="mdi-clock-outline"
                            class="promo-field"
                          />
                          <v-text-field
                            v-model="subRegla.Valor"
                            v-if="inputValor"
                            type="text"
                            placeholder="Valor"
                            label="Valor"
                            outlined
                            dense
                            prepend-inner-icon="mdi-pound"
                            class="promo-field"
                          />
                          <div class="input">
                            <Datepicker
                              class="mt-2"
                              v-if="inputDate"
                              v-model="subRegla.Valor"
                              input-class="promo-datepicker-input"
                            />
                            <Datepicker
                              class="mt-2"
                              v-if="inputMonth"
                              :format="'MMMM'"
                              :minimumView="'month'"
                              :maximumView="'month'"
                              v-model="subRegla.Valor"
                              input-class="promo-datepicker-input"
                            />
                            <Datepicker
                              class="mt-2"
                              v-if="inputYear"
                              :format="'yyyy'"
                              :minimumView="'year'"
                              :maximumView="'year'"
                              v-model="subRegla.Valor"
                              input-class="promo-datepicker-input"
                            />
                          </div>
                          <v-select
                            :items="days"
                            v-if="inputDayWeek"
                            v-model="subRegla.Valor"
                            outlined
                            dense
                            label="Día de la semana"
                            prepend-inner-icon="mdi-calendar-week"
                            class="promo-field"
                          >
                            <template v-for="(day, index) in days">
                              <option :key="index" :value="index + 1">
                                {{ day }}
                              </option>
                            </template>
                          </v-select>
                          <select
                            v-if="inputSex"
                            v-model="subRegla.Valor"
                            class="promo-native-select"
                          >
                            <option value="">-- Género --</option>
                            <option value="H">Hombre</option>
                            <option value="M">Mujer</option>
                          </select>
                        </v-col>
                      </v-row>

                      <v-btn
                        color="indigo"
                        dark
                        block
                        rounded
                        class="mt-2 promo-add-btn"
                        @click="addSubregla()"
                      >
                        <v-icon left>mdi-plus-circle</v-icon>
                        Agregar SubRegla
                      </v-btn>
                    </div>
                  </v-expand-transition>

                  <!-- ─── Campos de Acción ─── -->
                  <v-expand-transition>
                    <div v-if="tipoAccion != ''" class="promo-subform mt-2">
                      <div class="promo-subform-label">
                        <v-icon small color="teal" class="mr-1"
                          >mdi-lightning-bolt</v-icon
                        >
                        Configurar Acción
                      </div>

                      <!-- Etiqueta dinámica de valor -->
                      <div class="promo-valor-label caption grey--text mb-1">
                        <span
                          v-if="
                            tipoAccion == 'DescuentoFamilia' ||
                            tipoAccion == 'DescuentoCategoria' ||
                            tipoAccion == 'DescuentoProducto' ||
                            tipoAccion == 'DescuentoTotal'
                          "
                        >
                          <v-icon x-small color="teal">mdi-percent</v-icon>
                          Porcentaje de Descuento
                        </span>
                        <span v-if="tipoAccion == 'AbonoCashback'">
                          <v-icon x-small color="teal">mdi-cash-refund</v-icon>
                          Porcentaje Cashback
                        </span>
                        <span
                          v-if="
                            tipoAccion == 'RegaloCategoria' ||
                            tipoAccion == 'RegaloProducto' ||
                            tipoAccion == 'RegaloTags'
                          "
                        >
                          <v-icon x-small color="teal">mdi-gift</v-icon>
                          Cantidad
                        </span>
                      </div>

                      <v-text-field
                        @keypress="$pgsHelper.onlyNumber($event, accion.Valor)"
                        v-model="accion.Valor"
                        label="Valor"
                        outlined
                        dense
                        prepend-inner-icon="mdi-numeric"
                        class="promo-field"
                      />

                      <!-- Referencia de acción -->
                      <div
                        v-if="
                          inputAccionProducto ||
                          inputAccionCategoria ||
                          inputAccionFamilia ||
                          inputAccionTags ||
                          inputAcccionCashback
                        "
                      >
                        <div class="caption grey--text mb-1">
                          <v-icon x-small>mdi-link-variant</v-icon> Referencia
                        </div>

                        <v-text-field
                          v-model="accion.Ref"
                          v-if="inputAccionTags"
                          type="text"
                          placeholder="Tag para la acción"
                          label="Tag"
                          outlined
                          dense
                          prepend-inner-icon="mdi-tag"
                          class="promo-field"
                        />
                        <v-autocomplete
                          v-if="inputAccionProducto"
                          :items="productosSearch"
                          item-value="value"
                          item-text="text"
                          v-model="accion.Ref"
                          label="Seleccione un Producto"
                          outlined
                          dense
                          prepend-inner-icon="mdi-package-variant"
                          class="promo-field"
                          clearable
                        />
                        <v-autocomplete
                          v-if="inputAccionCategoria"
                          :items="categories"
                          item-value="value"
                          item-text="text"
                          v-model="accion.Ref"
                          label="Seleccione una Categoría"
                          outlined
                          dense
                          prepend-inner-icon="mdi-shape"
                          class="promo-field"
                          clearable
                        />
                        <v-autocomplete
                          v-if="inputAcccionCashback"
                          v-model="accion.Ref"
                          label="Categorías excluidas del cashback"
                          :items="categories"
                          item-value="value"
                          item-text="text"
                          multiple
                          outlined
                          dense
                          chips
                          small-chips
                          deletable-chips
                          prepend-inner-icon="mdi-tag-multiple-outline"
                          class="promo-field"
                        />
                        <v-autocomplete
                          v-if="inputAcccionCashback"
                          v-model="accion.SubRef"
                          label="Cliente al que se aplica"
                          :items="clientesSearch"
                          item-value="value"
                          item-text="text"
                          outlined
                          dense
                          prepend-inner-icon="mdi-account"
                          class="promo-field"
                        />
                        <v-autocomplete
                          v-if="inputAccionFamilia"
                          :items="Familias"
                          item-value="value"
                          item-text="text"
                          v-model="accion.Ref"
                          label="Seleccione una Familia"
                          outlined
                          dense
                          prepend-inner-icon="mdi-family-tree"
                          class="promo-field"
                          clearable
                        />
                      </div>

                      <v-btn
                        color="teal"
                        dark
                        block
                        rounded
                        class="mt-3 promo-add-btn"
                        @click="addAccion()"
                      >
                        <v-icon left>mdi-plus-circle</v-icon>
                        Agregar Acción
                      </v-btn>
                    </div>
                  </v-expand-transition>

                  <!-- Estado vacío del constructor -->
                  <div
                    v-if="tipoRegla === '' && tipoAccion === ''"
                    class="promo-builder-hint"
                  >
                    <v-icon size="48" color="grey lighten-2"
                      >mdi-gesture-tap</v-icon
                    >
                    <p class="grey--text text--lighten-1 body-2 mt-2 mb-0">
                      Selecciona un tipo de regla o acción para comenzar
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { mapActions } from "vuex";

export default {
  name: "PromocionesCreator",
  components: {
    Datepicker,
  },
  props: [],
  data() {
    return {
      appName: process.env.VUE_APP_NAME,
      unlimitDate: true,
      MainDepartamento: "",
      data_cliente: [],
      categories: [],
      promociones: [],
      gruposCliente: [],
      Familias: [],
      loading: false,
      catalogoReglas: "",
      typeOperation: 1,
      tipoRegla: "",
      tipoAccion: "",
      input_date: moment().format("MM/DD/YYYY"),
      subRegla: { Tipo: "", Operador: "", Valor: "", Ref: "" },
      Promocion: {
        Departamento: "",
        Departamentos: [],
        Nombre: "",
        Peso: 0,
        Membresia: false,
        Acciones: [],
        Vigencia: { E: false, I: "", F: "" },
        Reglas: { Tipo: "Todas", Reglas: [] },
      },
      dateI: "",
      dateF: "",
      accion: { Valor: "", Variacion: "", Ref: "", SubRef: "" },
      regla: { Tipo: "", Reglas: [] },
      days: [
        { value: 1, text: "Lunes" },
        { value: 2, text: "Martes" },
        { value: 3, text: "Miercoles" },
        { value: 4, text: "Jueves" },
        { value: 5, text: "Viernes" },
        { value: 6, text: "Sabado" },
        { value: 7, text: "Domingo" },
      ],
    };
  },
  methods: {
    selectDate(arg) {
      this.dateI = moment(arg);
    },
    selectDateFinal(arg) {
      this.dateF = moment(arg);
    },
    deleteAccion(index) {
      this.Promocion.Acciones.splice(index, 1);
    },
    deleteRule(parentIndex, index) {
      this.Promocion.Reglas.Reglas[parentIndex].Reglas.splice(index, 1);
      if (this.Promocion.Reglas.Reglas[parentIndex].Reglas.length === 0) {
        this.Promocion.Reglas.Reglas.splice(parentIndex, 1);
      }
    },
    isEmptyInput(value) {
      return (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === "string" && value.trim() === "")
      );
    },
    showValidationError(message) {
      this.$swal({
        title: "Validacion incompleta",
        text: message,
        icon: "error",
      });
      return false;
    },
    validateSubreglaForm() {
      if (
        this.isEmptyInput(this.tipoRegla) ||
        this.isEmptyInput(this.subRegla.Tipo) ||
        this.isEmptyInput(this.subRegla.Operador) ||
        this.isEmptyInput(this.subRegla.Valor)
      ) {
        return this.showValidationError(
          "Completa tipo de regla, subregla, operador y valor",
        );
      }
      if (
        (this.inputRefCategoria || this.inputRefProducto || this.inputRefTag) &&
        this.isEmptyInput(this.subRegla.Ref)
      ) {
        return this.showValidationError(
          "Debes capturar la referencia de la subregla",
        );
      }
      return true;
    },
    validateAccionForm() {
      if (
        this.isEmptyInput(this.tipoAccion) ||
        this.isEmptyInput(this.accion.Valor)
      ) {
        return this.showValidationError("Completa tipo de accion y valor");
      }
      if (
        (this.inputAccionProducto ||
          this.inputAccionCategoria ||
          this.inputAccionFamilia ||
          this.inputAccionTags) &&
        this.isEmptyInput(this.accion.Ref)
      ) {
        return this.showValidationError(
          "Debes capturar la referencia de la accion",
        );
      }
      if (this.inputAcccionCashback && this.isEmptyInput(this.accion.SubRef)) {
        return this.showValidationError("Selecciona el cliente para cashback");
      }
      return true;
    },
    validatePromocionBeforeSave() {
      if (
        this.isEmptyInput(this.Promocion.Nombre) ||
        this.isEmptyInput(this.dateI)
      )
        return this.showValidationError(
          "Nombre y fecha inicial son obligatorios",
        );
      if (!this.unlimitDate && this.isEmptyInput(this.dateF))
        return this.showValidationError("La fecha final es obligatoria");
      if (
        !this.unlimitDate &&
        moment(this.dateF).isBefore(moment(this.dateI), "day")
      )
        return this.showValidationError(
          "La fecha final no puede ser menor a la inicial",
        );
      if (
        !Array.isArray(this.Promocion.Departamentos) ||
        !this.Promocion.Departamentos.length
      )
        return this.showValidationError("Selecciona al menos un departamento");

      const reglaIncompleta = this.Promocion.Reglas.Reglas.some(
        (r) =>
        !r.Tipo ||
        !Array.isArray(r.Reglas) ||
        !r.Reglas.length ||
        r.Reglas.some((s) => {
            const c = Array.isArray(s.Reglas) ? s.Reglas[0] : null;
            return (
              !s.Tipo ||
              !c ||
              this.isEmptyInput(c.Tipo) ||
              this.isEmptyInput(c.Valor)
            );
          }),
      );
      if (reglaIncompleta)
        return this.showValidationError(
          "Hay reglas incompletas (falta operador o valor)",
        );
      if (
        this.Promocion.Acciones.some(
          (a) => this.isEmptyInput(a.Tipo) || this.isEmptyInput(a.Valor),
        )
      )
        return this.showValidationError("Hay acciones incompletas");
      return true;
    },
    preparePromocionForSave() {
      this.Promocion.Departamento = localStorage.getItem("selectedDepartment");
      this.Promocion.Vigencia.I =
        this.dateI != "" ? moment(this.dateI).format("YYYY-MM-DD") : null;
      this.Promocion.Vigencia.F =
        !this.unlimitDate && this.dateF
          ? moment(this.dateF).format("YYYY-MM-DD")
          : null;
      this.Promocion.Peso = Number(this.Promocion.Peso);
      return this.validatePromocionBeforeSave();
    },
    addAccion() {
      if (!this.validateAccionForm()) {
        return;
      }
      let variacion = "%";
      if (
        this.tipoAccion == "RegaloCategoria" ||
        this.tipoAccion == "RegaloProducto"
      ) {
        variacion = null;
      }
      let referencia = this.accion.Ref;
      if (this.tipoAccion == "AbonoCashback") {
        referencia = this.accion.SubRef + "|" + this.accion.Ref.toString();
      }

      this.Promocion.Acciones.push({
        Variacion: variacion,
        Valor: this.accion.Valor,
        Tipo: this.tipoAccion,
        Ref: referencia,
      });
      this.accion = { Valor: "", Variacion: "", Ref: "", SubRef: "" };
    },
    addSubregla() {
      if (!this.validateSubreglaForm()) {
        return;
      }
      this.regla.Tipo = this.tipoRegla;
      let existMainRule = this.$pgsHelper.getById(
        this.Promocion.Reglas.Reglas,
        "Tipo",
        this.tipoRegla,
      );
      if (this.tipoRegla == "Fecha") {
        if (this.subRegla.Tipo == "Date") {
          this.subRegla.Valor = moment(this.subRegla.Valor).format(
            "YYYY-MM-DD",
          );
        }
        if (this.subRegla.Tipo == "Year") {
          this.subRegla.Valor = moment(this.subRegla.Valor).format("YYYY");
        }
        if (this.subRegla.Tipo == "Month") {
          this.subRegla.Valor = moment(this.subRegla.Valor).format("M");
        }
      }
      if (!existMainRule) {
        this.Promocion.Reglas.Reglas.push({
          Tipo: this.tipoRegla,
          Reglas: [
            {
              Tipo: this.subRegla.Tipo,
              Reglas: [
                {
                  Valor: this.subRegla.Valor,
                  Tipo: this.subRegla.Operador,
                  Ref: this.subRegla.Ref,
                },
              ],
            },
          ],
        });
      } else {
        this.$pgsHelper.log(existMainRule);
        this.Promocion.Reglas.Reglas[existMainRule.idx].Reglas.push({
          Tipo: this.subRegla.Tipo,
          Reglas: [
            {
              Valor: this.subRegla.Valor,
              Tipo: this.subRegla.Operador,
              Ref: this.subRegla.Ref,
            },
          ],
        });
      }
      this.subRegla.Valor = "";
      this.subRegla.Ref = "";
    },
    changeDateLimit() {
      if (this.unlimitDate) {
        this.Promocion.Vigencia.F = null;
        this.dateF = "";
      }
    },
    async getRulesCatalogo() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Promociones",
      );
      if (!data.exists()) {
        return false;
      }
      let reglas = Object.entries(data.val());
      let parseCatalogo = {};
      reglas.forEach((catalogo) => {
        parseCatalogo[catalogo[0]] = catalogo[1];
      });

      parseCatalogo.Reglas = this.$pgsHelper.ArrayObjectToArray(
        parseCatalogo.Reglas,
      );
      parseCatalogo.Acciones = this.$pgsHelper.ArrayObjectToArray(
        parseCatalogo.Acciones,
      );
      this.catalogoReglas = parseCatalogo;
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getClientes() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Clientes", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ]);

      this.data_clientes = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      const cats = await this.fetchCategories();
      this.categories = cats.map((element) => ({
        value: element.id,
        text: element.label || `${element.Nombre} - ${element.Departamento}`,
      }));
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias",
        );
      let arrayFam = this.$pgsHelper.ArrayObjectToArray(data.val());
      let familias = [];
      arrayFam.forEach(function (element) {
        familias.push({ value: element.id, text: element.Nombre });
      });
      this.Familias = familias;
    },
    async getUserGroups() {
      this.gruposCliente = [];
    },
    changeRegla() {
      this.subRegla = { Tipo: "", Operador: "", Valor: "", Ref: "" };
    },
    changeAccion() {
      this.accion = { Valor: "", Variacion: "", Ref: "", SubRef: "" };
    },
    changeSubRegla() {
      this.subRegla.Valor = "";
    },
    async getPromoInfo(id) {
      this.loading = true;
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_Promociones/", id);
      var data = await firestore.getDoc(doc);

      let promo = { Id: data.ref.id, ...data.data() };

      if (!promo.Acciones) {
        promo.Acciones = [];
      }
      if (!promo.Reglas) {
        promo.Reglas = { Tipo: "Todas", Reglas: [] };
      } else if (!promo.Reglas.Reglas) {
        promo.Reglas.Reglas = [];
      }
      if (!promo.Departamentos) {
        promo.Departamentos = [];
      }

      this.Promocion = promo;

      this.dateI = moment(promo.Vigencia.I);

      this.dateF = promo.Vigencia.F ? moment(promo.Vigencia.F) : "";
      this.unlimitDate = !promo.Vigencia.F ? true : false;
      if (!this.unlimitDate) {
        this.Promocion.Vigencia.F = moment(promo.Vigencia.F).format(
          "YYYY-MM-DD",
        );
      }

      this.$pgsHelper.log(promo);
      this.loading = false;
    },

    addPromocion() {
      if (!this.preparePromocionForSave()) {
        return;
      }
      this.$pgsHelper.log(this.Promocion);
      this.$swal({
        title: "¿Deseas guardar la información de la promoción?",
        text: "La promoción aplicara segun las reglas y vigencias especificadas",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Promociones-createPromocion", this.Promocion)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La promoción se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.$router.push({
                path:
                  "/productos-inventarios/promocionesEditor/" +
                  (result.value.data.data.id || result.value.data.data.Id),
              });
            });
          } else {
            this.$swal(
              "Error saving Promoción",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },

    editPromocion() {
      if (!this.preparePromocionForSave()) {
        return;
      }
      this.$pgsHelper.log(this.Promocion);
      this.$swal({
        title: "¿Deseas guardar la información de la promoción?",
        text: "La promoción aplicara segun las reglas y vigencias especificadas",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Promociones-updatePromocion", this.Promocion)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La promoción se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.$router.push({
                path:
                  "/productos-inventarios/promocionesEditor/" +
                  (result.value.data.data.Id || result.value.data.data.id),
              });
            });
          } else {
            this.$swal(
              "Error saving Promoción",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
  },
  computed: {
    modulos() {
      let dep = [];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ key: element.id, value: element.id, text: element.Nombre });
      });
      return dep;
    },
    operables() {
      let operables = [];
      if (this.tipoRegla) {
        operables = this.$pgsHelper.getById(
          this.catalogoReglas.Reglas,
          "id",
          this.tipoRegla,
        ).Operables;
      }
      return operables;
    },
    clientesSearch() {
      let clienteComp = [];
      this.data_clientes.forEach((element) => {
        clienteComp.push({
          value: element.id,
          text: element.Nombres + " " + element.Apellidos,
        });
      });
      return clienteComp;
    },
    productosSearch() {
      let productos = this.$store.getters.getProductos;
      let productosComp = [];
      productos.forEach((element) => {
        if (!element.Dlat) {
          if (
            element.Tipo != "AYB-ICompuesto" &&
            element.Tipo != "AYB-Insumo"
          ) {
            productosComp.push({ value: element.id, text: element.Nombre });
          }
        }
      });
      return productosComp;
    },
    inputTarifa() {
      if (this.subRegla.Tipo == "Id" && this.tipoRegla == "Producto") {
        return true;
      }
      return false;
    },
    inputProducto() {
      if (this.subRegla.Tipo == "Id" && this.tipoRegla == "Producto") {
        return true;
      }
      return false;
    },
    inputTimeRange() {
      if (this.subRegla.Tipo == "Rango" && this.tipoRegla == "Hora") {
        return true;
      }
      return false;
    },
    inputCategoria() {
      if (this.subRegla.Tipo == "Categoria" && this.tipoRegla == "Producto") {
        return true;
      }
      if (this.subRegla.Tipo == "Id" && this.tipoRegla == "Categoria") {
        return true;
      }
      return false;
    },
    inputFamilias() {
      if (this.subRegla.Tipo == "Id" && this.tipoRegla == "Familia") {
        return true;
      }
      return false;
    },
    inputCliente() {
      if (this.subRegla.Tipo == "Id" && this.tipoRegla == "Cliente") {
        return true;
      }
      return false;
    },
    inputClienteGroup() {
      if (this.subRegla.Tipo == "Group" && this.tipoRegla == "Cliente") {
        return true;
      }
      return false;
    },
    inputSex() {
      if (this.subRegla.Tipo == "Sexo" && this.tipoRegla == "Cliente") {
        return true;
      }
      return false;
    },
    inputValor() {
      if (
        !this.inputTimeRange &&
        !this.inputCliente &&
        !this.inputCategoria &&
        !this.inputProducto &&
        !this.inputDate &&
        !this.inputYear &&
        !this.inputMonth &&
        !this.inputDayWeek &&
        !this.inputSex &&
        !this.inputFamilias &&
        !this.inputClienteGroup
      ) {
        return true;
      }

      return false;
    },
    inputDate() {
      if (this.subRegla.Tipo == "Date" && this.tipoRegla == "Fecha") {
        return true;
      }
      return false;
    },
    inputMonth() {
      if (this.subRegla.Tipo == "Month" && this.tipoRegla == "Fecha") {
        return true;
      }
      return false;
    },
    inputYear() {
      if (this.subRegla.Tipo == "Year" && this.tipoRegla == "Fecha") {
        return true;
      }
      return false;
    },
    inputRefProducto() {
      if (this.subRegla.Tipo == "CantCarrito" && this.tipoRegla == "Producto") {
        return true;
      }
      return false;
    },
    inputRefTag() {
      if (this.subRegla.Tipo == "CantCarrito" && this.tipoRegla == "Tags") {
        return true;
      }
      return false;
    },
    inputRefCategoria() {
      if (
        this.subRegla.Tipo == "CantCarrito" &&
        this.tipoRegla == "Categoria"
      ) {
        return true;
      }
      return false;
    },
    inputDayWeek() {
      if (this.subRegla.Tipo == "DayofWeek" && this.tipoRegla == "Fecha") {
        return true;
      }
      return false;
    },
    listaReglas() {
      let listReglas = [];
      this.Promocion.Reglas.Reglas.forEach((regla, parIndex) => {
        let mainRegla = regla.Tipo;
        regla.Reglas.forEach((subRegla, index) => {
          let valorName = "";
          let valorNameRef = "";
          if (mainRegla == "Producto" && subRegla.Tipo == "Id") {
            valorName = this.$pgsHelper.getById(
              this.productosSearch,
              "value",
              subRegla.Reglas[0].Valor,
            ).text;
          }
          if (mainRegla == "Producto" && subRegla.Tipo == "CantCarrito") {
            valorNameRef = this.$pgsHelper.getById(
              this.productosSearch,
              "value",
              subRegla.Reglas[0].Ref,
            ).text;
          }
          if (mainRegla == "Categoria" && subRegla.Tipo == "Id") {
            valorName = this.$pgsHelper.getById(
              this.categories,
              "value",
              subRegla.Reglas[0].Valor,
            ).text;
          }
          if (mainRegla == "Familia" && subRegla.Tipo == "Id") {
            valorName = this.$pgsHelper.getById(
              this.Familias,
              "value",
              subRegla.Reglas[0].Valor,
            ).text;
          }
          if (mainRegla == "Categoria" && subRegla.Tipo == "CantCarrito") {
            valorNameRef = this.$pgsHelper.getById(
              this.categories,
              "value",
              subRegla.Reglas[0].Ref,
            ).text;
          }
          if (mainRegla == "Cliente" && subRegla.Tipo == "Group") {
            valorName = this.$pgsHelper.getById(
              this.gruposCliente,
              "value",
              subRegla.Reglas[0].Valor,
            ).text;
          }
          if (mainRegla == "Cliente" && subRegla.Tipo == "Id") {
            valorName = this.$pgsHelper.getById(
              this.clientesSearch,
              "value",
              subRegla.Reglas[0].Valor,
            ).text;
          }

          listReglas.push({
            refName: valorNameRef,
            valorName,
            parentIndex: parIndex,
            objIndex: index,
            Regla: mainRegla,
            Subregla: subRegla.Tipo,
            Operador: subRegla.Reglas[0].Tipo,
            Valor: subRegla.Reglas[0].Valor,
            Ref: subRegla.Reglas[0].Ref,
          });
        });
      });

      return listReglas;
    },
    listaAcciones() {
      let listReglas = [];
      this.Promocion.Acciones.forEach((accion, parIndex) => {
        let valorName = "";
        let valorNameRef = "";
        let mainRegla = accion.Tipo;
        if (mainRegla == "DescuentoCategoria") {
          valorNameRef = this.$pgsHelper.getById(
            this.categories,
            "value",
            accion.Ref,
          ).text;
        }
        if (mainRegla == "DescuentoFamilia") {
          valorNameRef = this.$pgsHelper.getById(
            this.Familias,
            "value",
            accion.Ref,
          ).text;
        }
        if (mainRegla == "RegaloCategoria") {
          valorNameRef = this.$pgsHelper.getById(
            this.categories,
            "value",
            accion.Ref,
          ).text;
        }
        if (mainRegla == "DescuentoProducto") {
          valorNameRef = this.$pgsHelper.getById(
            this.productosSearch,
            "value",
            accion.Ref,
          ).text;
        }
        if (mainRegla == "DescuentoProducto") {
          valorNameRef = this.$pgsHelper.getById(
            this.productosSearch,
            "value",
            accion.Ref,
          ).text;
        }

        listReglas.push({
          refName: valorNameRef,
          valorName: valorName,
          ...accion,
        });
      });
      return listReglas;
    },
    inputAccionProducto() {
      if (
        this.tipoAccion == "RegaloProducto" ||
        this.tipoAccion == "DescuentoProducto"
      ) {
        return true;
      }
      return false;
    },
    inputAccionTags() {
      if (this.tipoAccion == "RegaloTags") {
        return true;
      }
      return false;
    },
    inputAccionCategoria() {
      if (
        this.tipoAccion == "RegaloCategoria" ||
        this.tipoAccion == "DescuentoCategoria"
      ) {
        return true;
      }
      return false;
    },
    inputAccionFamilia() {
      if (this.tipoAccion == "DescuentoFamilia") {
        return true;
      }
      return false;
    },
    inputAcccionCashback() {
      if (this.tipoAccion == "AbonoCashback") {
        return true;
      }
      return false;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.dateI = moment();
    this.getRulesCatalogo();
    this.getClientes();
    this.getCategories();
    this.getFamilias();
    this.getUserGroups();
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    if (this.$route.params.idPromocion) {
      this.getPromoInfo(this.$route.params.idPromocion);
    }
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════════
   VARIABLES & BASE
═══════════════════════════════════════════ */
.promo-app-bg {
  background-color: #f0f2f8 !important;
}

.promo-appbar-title {
  font-weight: 700;
  letter-spacing: 0.5px;
  font-size: 1rem;
}

.promo-mode-chip {
  font-weight: 600;
  font-size: 0.75rem;
}

.promo-loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* ═══════════════════════════════════════════
   SIDEBAR
═══════════════════════════════════════════ */
.promo-sidebar {
  border-radius: 16px !important;
  overflow: hidden;
  position: sticky;
  top: 80px;
}

.promo-sidebar-header {
  background: linear-gradient(135deg, #1a237e 0%, #283593 100%);
  color: white;
  padding: 14px 16px;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
}

.promo-sidebar-item {
  border-radius: 10px !important;
  margin: 2px 6px;
  transition: all 0.2s ease;
}

.promo-sidebar-item:hover {
  background-color: #e8eaf6 !important;
  transform: translateX(3px);
}

.promo-sidebar-item--save .v-list-item__title {
  color: #2e7d32;
  font-weight: 600;
}

.promo-sidebar-item--back .v-list-item__title {
  color: #c62828;
}

.promo-status-panel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  background: #f8f9ff;
  border-radius: 10px;
  border: 1px solid #e8eaf6;
}

.promo-status-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #9e9e9e;
  margin-bottom: 4px;
}

.promo-status-chip {
  width: fit-content;
}

/* ═══════════════════════════════════════════
   PANELS
═══════════════════════════════════════════ */
.promo-panel {
  border-radius: 16px !important;
  overflow: hidden;
}

.promo-panel-header {
  background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
  color: white;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
}

.promo-panel-header--builder {
  background: linear-gradient(135deg, #00695c 0%, #00897b 100%);
}

/* ═══════════════════════════════════════════
   FIELDS
═══════════════════════════════════════════ */
.promo-field {
  border-radius: 10px !important;
}

.promo-field .v-input__slot {
  border-radius: 10px !important;
}

.promo-section-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #546e7a;
  display: flex;
  align-items: center;
}

/* ═══════════════════════════════════════════
   SWITCHES
═══════════════════════════════════════════ */
.promo-switches-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.promo-switch-card {
  background: #f8f9ff;
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  padding: 6px 14px;
  flex: 1;
  min-width: 140px;
}

.promo-switch {
  margin-top: 0 !important;
}

/* ═══════════════════════════════════════════
   DATEPICKER
═══════════════════════════════════════════ */
.promo-date-block {
  background: #f8f9ff;
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  padding: 10px 14px;
}

.promo-date-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #546e7a;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.promo-datepicker-wrapper :deep(.vdp-datepicker__calendar) {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: none;
}
</style>

<style>
/* ═══════════════════════════════════════════
   DATEPICKER INPUT (global, necesario por el componente externo)
═══════════════════════════════════════════ */
.promo-datepicker-input {
  border: none;
  border-bottom: 2px solid #90caf9;
  background: transparent;
  font-size: 0.95rem;
  padding: 4px 0;
  width: 100%;
  outline: none;
  color: #1a237e;
  font-weight: 600;
  transition: border-color 0.2s;
}
.promo-datepicker-input:focus {
  border-bottom-color: #1565c0;
}

/* ═══════════════════════════════════════════
   TABLES
═══════════════════════════════════════════ */
.promo-table {
  border-radius: 10px !important;
  overflow: hidden;
  border: 1px solid #e8eaf6;
}

.promo-table thead th {
  background-color: #e8eaf6 !important;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #3949ab !important;
  padding: 8px 10px !important;
}

.promo-table-row {
  transition: background-color 0.15s ease;
}

.promo-table-row:hover {
  background-color: #f3f4fd !important;
}

.promo-table td {
  padding: 6px 10px !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

/* ═══════════════════════════════════════════
   EMPTY STATE
═══════════════════════════════════════════ */
.promo-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #fafafa;
  border: 2px dashed #e0e0e0;
  border-radius: 12px;
  margin-bottom: 8px;
}

/* ═══════════════════════════════════════════
   TOGGLE BUTTONS (Regla / Acción)
═══════════════════════════════════════════ */
.promo-toggle-group {
  display: flex;
  background: #eceff1;
  border-radius: 50px;
  padding: 4px;
  gap: 4px;
}

.promo-toggle-btn {
  flex: 1;
  padding: 8px 16px;
  border: none;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  color: #546e7a;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.promo-toggle-btn:hover {
  background: #cfd8dc;
  color: #263238;
}

.promo-toggle-btn--active {
  background: linear-gradient(135deg, #1565c0, #1976d2);
  color: white !important;
  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.35);
}

/* ═══════════════════════════════════════════
   SUBFORM
═══════════════════════════════════════════ */
.promo-subform {
  background: #f8f9ff;
  border: 1px solid #e8eaf6;
  border-radius: 14px;
  padding: 16px;
}

.promo-subform-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #546e7a;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.promo-valor-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
}

.promo-add-btn {
  letter-spacing: 0.5px;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
}

/* ═══════════════════════════════════════════
   NATIVE SELECT (Género)
═══════════════════════════════════════════ */
.promo-native-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #b0bec5;
  border-radius: 10px;
  font-size: 0.9rem;
  color: #37474f;
  background: white;
  margin-bottom: 16px;
  outline: none;
  transition: border-color 0.2s;
}

.promo-native-select:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.15);
}

/* ═══════════════════════════════════════════
   BUILDER HINT
═══════════════════════════════════════════ */
.promo-builder-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}
</style>
